function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.38L.62 7l3.5-3.5L.62 0 0 .62 2.88 3.5 0 6.38z",
  fill: "#337DF6"
});

function SvgRightChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "2956d62e51cf53559426135fb0ce3601.svg";
export { SvgRightChevron as ReactComponent };